import { Button, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { QRCodeCanvas } from "qrcode.react";
import React, { useRef } from "react";
import generatePDF from "react-to-pdf";

export default function QRGeneratorView({ value, labeldata }) {
  const componentRef = useRef();
  const downloadPdf = () =>
    generatePDF(
      () => {
        return componentRef.current;
      },
      {
        method: "open",
      }
    );

  return labeldata ? (
    <Grid container>
      <Grid item container xs={12} ref={componentRef} style={{ padding: 5 }}>
        <Grid item xs={4}>
          <QRCodeCanvas
            {...{
              width: 200,
              value: value,
            }}
          />
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={7}>
          {labeldata &&
            Object.keys(labeldata).map(
              (f) =>
                labeldata[f] && (
                  <Typography style={{ padding: 5 }}>
                    {f.toUpperCase()}: {labeldata[f]}
                  </Typography>
                )
            )}
        </Grid>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            downloadPdf().then((pdf) => {});
          }}
        >
          PRINT
        </Button>
      </Grid>
    </Grid>
  ) : null;
}
